import { Inject, Injectable, TemplateRef } from '@angular/core';
import {
  ContentContainerStore,
  SidenavState
} from '@app/core/containers/content-container/store/content-container.store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {
  constructor(@Inject('ContentContainerStore') private store: ContentContainerStore) {}

  open(template: TemplateRef<any>, disableClose = false, panelClass = ''): Observable<SidenavState> {
    this.openSidenav(template, disableClose, panelClass);
    return this.store.state$.pipe(map(state => state.sidenav));
  }

  openSidenav(template: TemplateRef<any>, disableClose = false, panelClass = '') {
    let sidenavState: SidenavState = {
      opened: true,
      template,
      disableClose,
      panelClass
    };
    this.store.sidenavState = sidenavState;
  }

  closeSidenav(template?: TemplateRef<any>, meta?: any) {
    let sidenavState: SidenavState = {
      opened: false,
      template,
      meta
    };
    this.store.sidenavState = sidenavState;
  }
}
